// import TicketMenuManagementCreate from "./lib/create";
import EventsTable from './lib/table';
import Gap from 'components/gap';
import { useTypedSelector } from 'common/hooks/useTypedSelector';
import AppLoading from 'components/appLoading';

import PageTitle from 'components/pageTitle';

import * as S from './styles';

export default function AccessManagementLeaveRequestsPage() {
  const { tickets, ticketCategory } = useTypedSelector((state) => state.Tickets);
  const { departments } = useTypedSelector((state) => state.Departments);

  return (
    <S.Container>
      <S.Head>
        <PageTitle title="Leave Requests" />
      </S.Head>
      <Gap size="20px" />
      <EventsTable
        data={tickets.data}
        departments={departments.data}
        ticketCategory={ticketCategory.data}
        loading={tickets.loading}
      />

      <AppLoading loading={tickets.loading || departments.loading || ticketCategory.loading} />
    </S.Container>
  );
}
